module.exports = __webpack_public_path__ + "img/sec1_6.0f26940a.png";